"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M15.11 12.45 14 10.24l-3.11 6.21c-.16.34-.51.55-.89.55s-.73-.21-.89-.55L7.38 13H2v7h20v-7h-6c-.38 0-.73-.21-.89-.55"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M22 4H2v7h6c.38 0 .73.21.89.55L10 13.76l3.11-6.21c.37-.74 1.42-.74 1.79 0L16.62 11H22z"
}, "1")], 'MonitorHeartSharp');